import { htmlEnc } from './htmlEnc';

// The single-curly will cause values to be escaped
const PLACEHOLDER_ESC = /\{(\w+)\}/g;
// The double-curly will cause values to be inserted as raw HTML
const PLACEHOLDER_NO_ESC = /\{\{(\w+)\}\}/g;

/**
 * Replace placeholders with values.
 * Notes:
 * - Unescaped (raw content) placeholders `{{foo}}` are processed in the first
 *   pass, and escaped placeholders `{foo}` in a second pass
 * - Placeholders have whitespace trimmed so `{ foo }` is equivalent to `{foo}`
 * - Placeholders are normalized to lowercase and stripped of separators
 *   (underscore and space) so `{Foo_Bar}` is equivalent to `{fooBar}`
 */
export function render(html: string, fields: ObjectOf<unknown>) {
  let normalizeKey = (key: string) => key.toLowerCase().replace(/[_ ]+/g, '');
  let fieldMap = new Map(
    Object.entries(fields).map(
      ([key, value]) => [normalizeKey(key), value] as const,
    ),
  );
  return html
    .replace(PLACEHOLDER_NO_ESC, (match, name) => {
      let key = normalizeKey(String(name));
      return fieldMap.has(key) ? String(fieldMap.get(key)) : match;
    })
    .replace(PLACEHOLDER_ESC, (match, name) => {
      let key = normalizeKey(String(name));
      return fieldMap.has(key) ? htmlEnc(fieldMap.get(key)) : match;
    });
}
